module.exports = __webpack_public_path__ + "img/import-monitors.79c5f5e9.svg";